import { apiCall2 } from "components/Api/api";
import { handleError } from "components/Api/handleError";

export const fetchAllComments = async (url, dispatch, logout, navigate, setLoading = () => {}) => {
    try {
        setLoading(true);
        let currentPage = 1;
        const pageSize = 10;
        let allComments = [];
        let totalComments = 0;
        let totalPages = 1;

        do {
            const response = await apiCall2({
                url: `${url}?page=${currentPage}&pageSize=${pageSize}`,
                method: "GET",
            });

            if (response.status !== 200) {
                throw new Error(`Unexpected status code: ${response.status}`);
            }

            const apiData = response.data;
            const commentsData = apiData.comments?.data || [];
            const summary = apiData.comments?.summary;

            allComments = [...allComments, ...commentsData];
            totalPages = summary?.total_page || 1;
            currentPage++;

        } while (currentPage <= totalPages);

        dispatch({ type: "SET_PACKAGE_VIEW_USERS_COMMENTS", payload: allComments });

    } catch (error) {
        handleError(error, logout, navigate);
    } finally {
        setLoading(false);
    }
};